import baseApi from "./base"
import { Apply1Request, Apply1Response } from "./types/apply"
import { RefreshCaptcha1Request, RefreshCaptcha1Response } from "./types/refreshCaptcha"
import { GetCaptcha1Response, GetCaptcha1Request } from "./types/captcha"
import { GetTokenByTckn1Response } from "./types/token"

const api = baseApi.injectEndpoints({
  overrideExisting: false,
  endpoints: (builder) => ({
    getTokenByTckn1: builder.mutation<GetTokenByTckn1Response, string>({
      query: (body) => ({
        url: "",
        method: "POST",
        body: {
          tckn: body,
          functionCode: "SPE0012",
          NextTransactionUrl: "Facebook/SocialMediaPortalCreateSession/GetTokenByTckn1",
          TokenSessionId: "ABCDEFABCDEFABCDEFABCDEFABCDEFABCDEF"
        }
      }),
      transformResponse: (response: string) => JSON.parse(response)
    }),
    getCaptcha: builder.mutation<GetCaptcha1Response, GetCaptcha1Request>({
      query: (body) => ({
        url: "",
        method: "POST",
        body: {
          guid: body.guid,
          TokenSessionId: body.TokenSessionId,
          functionCode: "SPE0012",
          NextTransactionUrl: "Facebook/PrivateBanking/GetCaptcha1"
        }
      }),
      transformResponse: (response: string) => JSON.parse(response)
    }),
    refreshCaptcha: builder.mutation<RefreshCaptcha1Response, RefreshCaptcha1Request>({
      query: (body) => ({
        url: "",
        method: "POST",
        body: {
          guid: body.guid,
          functionCode: "SPE0012",
          NextTransactionUrl: "Facebook/PrivateBanking/RefreshCaptcha1",
          TokenSessionId: body.TokenSessionId
        }
      }),
      transformResponse: (response: string) => JSON.parse(response)
    }),
    apply1: builder.mutation<Apply1Response, Apply1Request>({
      query: (body) => ({
        url: "",
        method: "POST",
        body: {
          guid: body.guid,
          nameSurname: body.nameSurname,
          phone: body.phone,
          email: body.email,
          isCustomer: body.isCustomer,
          mbbNo: body.mbbNo,
          forgetMbbNo: body.forgetMbbNo,
          captcha: body.captcha,
          kvkk: body.kvkk,
          NextTransactionUrl: "Facebook/PrivateBanking/Apply1",
          TokenSessionId: body.TokenSessionId
        }
      }),
      transformResponse: (response: string) => JSON.parse(response)
    })
  })
})

export const {
  useGetTokenByTckn1Mutation,
  useGetCaptchaMutation,
  useRefreshCaptchaMutation,
  useApply1Mutation
} = api

export default api
